import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    previewUrl: String
  }

  connect() {
    this.abortController = null
    this.previewTimeout = null
  }

  disconnect() {
    this.abortPendingRequest()
    clearTimeout(this.previewTimeout)
  }

  preview() {
    clearTimeout(this.previewTimeout)
    this.previewTimeout = setTimeout(() => this.submitPreview(), 250)
  }

  async submitPreview() {
    if (!this.hasPreviewUrlValue || !this.previewUrlValue) return

    this.abortPendingRequest()
    this.abortController = new AbortController()

    const response = await fetch(this.previewUrlValue, {
      method: "POST",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": this.csrfToken
      },
      body: new FormData(this.element),
      credentials: "same-origin",
      signal: this.abortController.signal
    })

    if (!response.ok) return

    Turbo.renderStreamMessage(await response.text())
  }

  abortPendingRequest() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = null
    }
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
